// Shared avatar for people: an uploaded image if the linked contact has one,
// else tinted initials in the speaker/contact colour. Used by the transcript
// feed, the speaker rail, and the contacts page so a person looks identical
// everywhere. Size + ring come from `className`; default is the feed's size-7.

import { cn } from '@/lib/utils'
import { initialsOf } from '@/lib/contacts/types'

// Speaker/contact text-color utility → matching tinted background. Listed as
// literals so Tailwind's scanner keeps the classes (a runtime-built string would
// be tree-shaken out).
export const AVATAR_BG: Record<string, string> = {
  'text-accent': 'bg-accent/15',
  'text-success': 'bg-success/15',
  'text-warn': 'bg-warn/15',
  'text-danger': 'bg-danger/15',
  'text-text': 'bg-text/15',
  'text-muted-foreground': 'bg-muted-foreground/15'
}

export function ContactAvatar({
  name,
  color,
  avatar,
  className
}: {
  name: string
  color: string
  avatar: string | null
  className?: string
}) {
  if (avatar) {
    return (
      <img
        src={avatar}
        alt={name}
        className={cn('size-7 shrink-0 rounded-full object-cover', className)}
      />
    )
  }
  return (
    <span
      className={cn(
        'grid size-7 shrink-0 place-items-center rounded-full text-code font-semibold',
        AVATAR_BG[color] ?? 'bg-muted-foreground/15',
        color,
        className
      )}
    >
      {initialsOf(name)}
    </span>
  )
}
